var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro {\n  height: 100%;\n  width: 100%;\n  background: url(" + escape(require("../../../assets/image/frontImage.jpg")) + ") no-repeat center fixed;\n  display: table;\n  margin: 0; }\n\n.intro .inner {\n  vertical-align: middle;\n  width: 100%;\n  max-width: none;\n  margin-top: 40%; }\n\n.content {\n  max-width: 500%;\n  margin: 0 auto;\n  text-align: center; }\n\n.content h1 {\n  font-family: 'Relway', sans-serif;\n  color: #fff;\n  font-size: 70px; }\n\n.content h5 {\n  color: gray; }\n\n.btn {\n  border-radius: 9px;\n  font-family: 'Oswald', sans-serif;\n  color: #036Ab1;\n  font-size: 100%;\n  padding: 10px 20px;\n  border: solid  1px;\n  text-decoration: none; }\n\n.btn:hover {\n  border: solid #036Ab1 1px;\n  font-family: sans-serif #036Ab1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/yanir/Desktop/workspace/TheBooksLibrary/src/app/components/page-header/page-header.component.scss
// module id = ../../../../../src/app/components/page-header/page-header.component.scss
// module chunks = main